import { post } from './api';

export const authAPI = {
  login(loginData) {
    return post('admin/login', loginData);
  },
};
